import React from 'react';
import { DebouncedTextField } from '../../inputs';

const DESCRIPTION_INPUT_STYLE = {
  marginBottom: 0,
  minHeight: '60px',
  resize: 'vertical',
};

export default function SystemDescriptionFields({
  system,
  onPatch,
  labelStyle,
  inputStyle,
}) {
  return (
    <>
      <div style={{ gridColumn: '1 / span 2' }}>
        <DebouncedTextField
          as="textarea"
          label={<span style={labelStyle}>Internal Description</span>}
          style={{ ...inputStyle, ...DESCRIPTION_INPUT_STYLE }}
          value={system.description || ''}
          onCommit={(value) => onPatch({ description: value })}
          unmountPolicy="flush"
        />
      </div>
      <div style={{ gridColumn: '1 / span 2' }}>
        <DebouncedTextField
          as="textarea"
          label={<span style={labelStyle}>Public Description (optional)</span>}
          style={{ ...inputStyle, ...DESCRIPTION_INPUT_STYLE }}
          value={system.publicDescription || ''}
          onCommit={(value) => onPatch({ publicDescription: value })}
          placeholder="What players see if details are revealed"
          unmountPolicy="flush"
        />
      </div>
    </>
  );
}
